import { isUrlDev } from '@frontend/utils/tenant';
import { createServerFn } from '@tanstack/react-start';
import { getCookie, getRequest, setCookie } from '@tanstack/react-start/server';

export const setIsDemoDataCookie = createServerFn({ method: 'POST' })
	.inputValidator((data: { is: boolean }) => data)
	.handler(async ({ data: { is } }) => {
		setCookie('isDemo', is ? 'true' : 'false');
	});

export const getIsDemoDataCookie = createServerFn({ method: 'GET' }).handler(
	async () => {
		const req = getRequest();
		const isDemo = getCookie('isDemo');

		// Prod Check
		const isProd = !import.meta.env.DEV && !isUrlDev(req.url);

		if (typeof isDemo === 'undefined') {
			await setIsDemoDataCookie({ data: { is: !isProd } });
			return !isProd;
		}

		if (isProd && isDemo === 'true') {
			await setIsDemoDataCookie({ data: { is: false } });
			return false;
		}

		return isDemo === 'true';
	},
);
